import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import VideoCard from '@/components/feature/VideoCard';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { videos, categories } from '@/mocks/videos';

export default function Category() {
  const { slug = 'all' } = useParams<{ slug: string }>();

  const currentCategory = categories.find((c) => c.slug === slug);
  const filteredVideos = slug === 'all'
    ? videos
    : videos.filter((v) => v.categorySlug === slug);

  const pageTitle = slug === 'all'
    ? '全部视频 - 吃瓜视频'
    : `${currentCategory?.name || '分类'} - 吃瓜视频`;
  const pageDescription = slug === 'all'
    ? '吃瓜视频全部视频合集，涵盖明星吃瓜、娱乐八卦、社会热点、综艺爆料、网红动态等分类。每日实时更新，一站式观看最新最热吃瓜视频。'
    : `吃瓜视频${currentCategory?.name || '分类'}频道，精选${currentCategory?.name || ''}相关最新最热视频内容，每日更新，来这里吃最新鲜的瓜！`;

  const breadcrumbItems = [
    { label: '首页', to: '/' },
    { label: currentCategory?.name || '全部分类' },
  ];

  const webpageSchema = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: pageTitle,
    description: pageDescription,
    url: `https://readyue.cn/category/${slug}`,
    isPartOf: {
      '@type': 'WebSite',
      name: '吃瓜视频',
      url: 'https://readyue.cn',
    },
  };

  return (
    <>
      <Navbar />
      <ScrollToTop />
      <main>
        <script type="application/ld+json">{JSON.stringify(webpageSchema)}</script>

        <div className="w-full px-4 md:px-6 pt-6 pb-4">
          <div className="max-w-7xl mx-auto">
            <Breadcrumb items={breadcrumbItems} />
          </div>
        </div>

        <section className="w-full px-4 md:px-6 py-4 md:py-6">
          <div className="max-w-7xl mx-auto">
            <div className="mb-6">
              <h1 className="text-xl md:text-2xl font-bold text-foreground-900">
                {currentCategory?.name || '全部分类'}
              </h1>
              <p className="text-sm text-foreground-500 mt-1">
                共 {filteredVideos.length} 个视频 · 每日实时更新
              </p>
            </div>

            <div className="flex items-center gap-2 mb-6 flex-wrap">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs md:text-sm font-medium whitespace-nowrap cursor-pointer transition-all duration-200 ${
                    slug === cat.slug
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-800'
                  }`}
                >
                  <i className={`${cat.icon} text-xs`}></i>
                  {cat.name}
                </Link>
              ))}
            </div>

            {filteredVideos.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
                {filteredVideos.map((v) => (
                  <VideoCard key={v.id} video={v} variant="default" />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-100 text-foreground-400">
                  <i className="ri-inbox-line text-2xl"></i>
                </div>
                <p className="text-sm text-foreground-500">该分类下暂无视频内容</p>
                <Link
                  to="/category/all"
                  className="inline-block mt-4 px-4 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  查看全部视频
                </Link>
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}